module.exports = __webpack_public_path__ + "static/img_1321-46678a8fd83b97fb17b3db66066e03ed.webp";